/* eslint-disable no-param-reassign, no-unused-vars */
import jwtDecode from "jwt-decode";
import api from "../utils/api";
import windowHelper from "../utils/window";
import redirect from "../utils/redirect";

const { cookieDisabled } = windowHelper();
if (cookieDisabled && window.location.pathname !== "/app/unauthorized") {
  redirect("/app/unauthorized?checkPrivacySettings=true");
}

const ls = windowHelper().localStorage;

export const validateToken = (token, appName = "") => {
  try {
    const decoded = jwtDecode(token);
    ls.setItem(`dpaID-token${appName ? `-${appName}` : ""}`, token);
    return decoded;
  } catch (e) {
    throw e;
  }
};

export default ({ services, apiVersion, appName } = { appName: "" }) => {
  const { get } = api({ services, apiVersion });

  const apiCheckTos = async ({ token }) => {
    try {
      const data = await get({
        url: "useradmin/confirmPrivacyAndToSConsent",
        authJWT: token
      });
      return {
        token: data.token
      };
    } catch (e) {
      return e;
    }
  };

  const invalidateToken = () =>
    ls.setItem(`dpaID-token${appName ? `-${appName}` : ""}`, "");

  const state = {
    token: ls.getItem(`dpaID-token${appName ? `-${appName}` : ""}`) || "",
    status: ""
  };

  const getters = {
    isAuthenticated: ({ token }) => {
      try {
        return !!validateToken(token, appName);
      } catch (e) {
        return false;
      }
    },
    authStatus: ({ status }) => status,
    validateAndRetrieveToken: ({ token }, _, rootState) => () => {
      const { profile } = rootState.user;
      // NB: Compare `exp` stamp against 5s from `now`: this will prevent a soon-to-expire token being sent and invalidated in the BE
      const now = new Date(Date.now() + 5000);
      const tokenExpDate = new Date(profile.exp * 1000);
      const isExpired = now >= tokenExpDate;
      return !isExpired && token;
    }
  };

  const actions = {
    async authenticate({ commit }, { token }) {
      try {
        commit("setStatusLoading");
        validateToken(token, appName);
        commit("setStatusSuccess", { token });
        return true;
      } catch (e) {
        console.error(e); // eslint-disable-line
        commit("setStatusError");
        return false;
      }
    },
    logout({ commit }) {
      invalidateToken();
      commit("setStatusLoggedOut");
    },
    async checkTOS({ commit, state }) {
      try {
        const { token } = await apiCheckTos(state);
        commit("setToken", { token });
        return true;
      } catch (e) {
        commit("setStatusError");
        return false;
      }
    }
  };

  const mutations = {
    setStatusLoading({ status }) {
      status = "loading";
    },

    setStatusSuccess(state, { token }) {
      state.status = "loggedin";
      state.token = token;
    },

    setToken(state, { token }) {
      state.token = token;
    },

    setStatusError(state) {
      state.status = "error";
      state.token = "";
    },

    setStatusLoggedOut(state) {
      state.status = "loggedout";
      state.token = "";
    }
  };

  return {
    state,
    getters,
    actions,
    mutations,
    namespaced: true
  };
};
